import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "./cn";
export function Card({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card", className: cn("rounded-xl border border-border bg-card text-card-foreground shadow-sm", className), ...props }));
}
export function CardHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-header", className: cn("flex flex-col gap-2 p-6", className), ...props }));
}
export function CardTitle({ className, ...props }) {
    return (_jsx("h2", { "data-slot": "card-title", className: cn("text-2xl font-semibold tracking-tight", className), ...props }));
}
export function CardDescription({ className, ...props }) {
    return (_jsx("p", { "data-slot": "card-description", className: cn("text-sm text-muted-foreground", className), ...props }));
}
export function CardContent({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-content", className: cn("p-6 pt-0", className), ...props }));
}
export function CardFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-footer", className: cn("flex items-center p-6 pt-0", className), ...props }));
}
//# sourceMappingURL=card.js.map